import React from "react";
import { _t } from "app/i18n/i18n";
import { Form, Button } from "react-bootstrap";
import { useQueryParams } from "lib/hooks/useQueryParams";
import { push, setParam } from "pages/search/api/filterUrlMaker";
import { features } from "app/features";

export const DateFilterControls = ({pastEventDate}) => {
  const qsDate = useQueryParams().eventDate || pastEventDate;
  const setDate = (ev) => push(setParam("eventDate", ev.target.value));
  const isActiveClass = (date) => (date === qsDate ? "dark " : "outline-dark ");

  return (
    <section>
      <Button value="1month" variant={isActiveClass("1month") + "mr-3"} onClick={setDate}>
        {_t("Last 30 days")}
      </Button>
      <Button value="ytd" variant={isActiveClass("ytd") + "mr-3"} onClick={setDate}>
        {_t("Year to date")}
      </Button>
      <Button value="1year" variant={isActiveClass("1year") + "mr-3"} onClick={setDate}>
        {_t("One year")}
      </Button>
    </section>
  );
};

export const LanguageLocationFilterControls = () => {
    if (features.eventFilters.showLocationFilters && features.eventFilters.showLanguageFilters) return (
        <aside className="d-flex gap">
            <LanguageDropdown/>
            <LocationDropdown/>
        </aside>
    )
    else if (!features.eventFilters.showLocationFilters && features.eventFilters.showLanguageFilters) return (
        <aside className="d-flex gap">
            <LanguageDropdown/>
        </aside>)
    else if (features.eventFilters.showLocationFilters && !features.eventFilters.showLanguageFilters) return (
        <aside className="d-flex gap">
            <LocationDropdown/>
        </aside>)
    else return null
};

const LanguageDropdown = () => {
  const qsLanguage = useQueryParams().eventLanguage || "";
  const setLanguage = (ev) => push(setParam("eventLanguage", ev.target.value));

  return (
    <Form.Control as="select" defaultValue={qsLanguage} onChange={setLanguage}>
      <option value="">{_t("All Languages")}</option>
      <option value="English">{_t("English")}</option>
      <option value="Mandarin">{_t("Chinese (Mandarin)")}</option>
    </Form.Control>
  );
};

const LocationDropdown = () => {
  const qsLocation = useQueryParams().eventLocation || "";
  const setLocation = (ev) => push(setParam("eventLocation", ev.target.value));

  return (
    <Form.Control as="select" defaultValue={qsLocation} onChange={setLocation}>
      <option value="">{_t("All Locations")}</option>
      <option value="VIDEO_CONFERENCE">{_t("Virtual Events")}</option>
      <option value="CORPORATE_OFFICE">{_t("Physical Location")}</option>
    </Form.Control>
  );
};
